import { InjectionToken } from '@angular/core';
import { EmployeeConfigurationsPort } from './employee-configurations.port';

export const EMPLOYEE_CONFIGURATIONS_PORT = new InjectionToken<EmployeeConfigurationsPort>('EMPLOYEE_CONFIGURATIONS_PORT');
